import {Directive, ElementRef, Injector, Input} from "@angular/core";
import {UpgradeComponent} from "@angular/upgrade/static";

@Directive({ selector: "tva-ui-grid" })
export class UiGridComponent extends UpgradeComponent {
  @Input() gridOptions;

  constructor(ref: ElementRef, inj: Injector) {
    super("uiGridMigration", ref, inj);
  }
}
